/*
 * @Author: your name
 * @Date: 2020-05-26 19:40:04
 * @LastEditTime: 2020-06-01 17:02:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \client-v4\src\api\good.js
 */
/**
 * auth模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../request/http'; // 导入http中创建的axios实例
// import qs from 'qs'; // 根据需求是否导入qs模块

const good = {
    //获取产品类别目录
    goodGetByType(query, id) {
        return axios.get(base.dev + '/categories/' + id + '/produits', {params: query});
    },
    //获取目录层级
    getType(query) {
        return axios.get(`${base.dev}/categories`, {params: query});
    },
    //获取特定目录层级
    getCategories(query, id) {
        return axios.get(`${base.dev}/categories/${id}`, {params: query});
    },
    // 获取新品
    goodNewGet(query) {
        return axios.get(`${base.dev}/v2/produits/newArrival`, {params: query});
    },
    // 获取最佳销售
    goodBest(query) {
        return axios.get(`${base.dev}/v2/produits/bestSales`, {params: query});
    },
    // 搜索产品
    search(query) {
        return axios.get(`${base.dev}/v2/produits/search`, {params: query});
    },
    // 记录用户的搜索内容
    addTrackSearch(body) {
        if (!this.$store.state.token) return;
        return axios.post(`${base.dev}/v2/produits/trackingSearch`, body);
    },
    // 获取所有分类的产品列表
    getProduits(body) {
        return axios.get(`${base.dev}/produits`, {params: body});
    },
    // 获取激活的趋势数据
    get_tendances(body) {
        return axios.get(`${base.dev}/v2/produits/get_tendances`, body);
    },
    // 获取新品的数量
    get_new_prod_count(body) {
        return axios.get(`${base.dev}/v2/produits/get_new_prod_count`, {params: body});
    },
    // 其他接口…………
}

export default good;
